// Job data for different positions
export const JOB_POSITIONS = {
  AI_ENGINEER: {
    id: 1,
    title: "AI Engineer (Operations Research)",
    type: "Full-time or Internship",
    location: "Remote",
    summary: "Work on real aviation challenges using optimisation, algorithms, and data. Ideal for those skilled in Python, operations research, and solvers like Gurobi. A great fit if you enjoy problem-solving and want to grow fast in a startup.",
    description: "We are hiring an AI Engineer with expertise in operations research. You can apply as a full-time team member or intern. You will work on AI tools that solve real operations problems. Tasks include analysing data, building models, and integrating solutions into our systems. The focus is on operations research and algorithm design. Your work will help clients improve operations and make better decisions. We're looking for someone who knows AI and operations research deeply. You should be able to build scalable models, write clean backend code, and turn research and models into working tools.",
    responsibilities: [
      "Setup and manage the literature review and research process for AI in aviation",
      "Summarise key findings for the product team",
      "Analyse data and trends using statistical techniques for actionable insights",
      "Design math models and optimisation algorithms",
      "Work with engineers and data scientists to deploy solutions into broader system architectures",
      "Optional: Prepare ML datasets for supervised, unsupervised and reinforcement learning, focusing on neural architecture search and feature extraction",
      "Optional: Manage data warehouse for scalability and performance for model training and testing"
    ],
    skills: [
      "Degree in Operations Research, Systems Engineering, Data Science, Computer Science, Maths, Statistics, Physics or related fields",
      "Experience in mathematical programming and algorithm design",
      "Familiar with Vehicle Routing Problem (VRP) and integer programming",
      "Experience with solvers like Gurobi or SCIP",
      "Skilled in Python",
      "Able to review and summarise research papers",
      "Strong analytical, problem-solving skills and attention to detail",
      "Good English communication and teamwork",
      "Interest in startups and solving real problems"
    ],
    benefits: [
      "Real exposure and fast learning curve",
      "Join a growing tech company",
      "Work on AI for aviation, logistics, and transport",
      "Meritocracy-based culture where ideas matter more than titles",
      "Flexible hours and fully remote team",
      "Reward based on value",
      "A positive and dynamic team"
    ],
    applicationEmail: "ruby.lau@neurallab.io",
    responseTime: "We'll reply within three business days."
  }
  // Future job positions can be added here
  // DATA_SCIENTIST: { ... },
  // FRONTEND_DEVELOPER: { ... },
  // etc.
};

// Helper function to get job data by ID
export const getJobById = (jobId) => {
  return Object.values(JOB_POSITIONS).find(job => job.id === jobId);
};

// Helper function to get job data by title
export const getJobByTitle = (title) => {
  return Object.values(JOB_POSITIONS).find(job => job.title === title);
};
